module.exports = __webpack_public_path__ + "static/media/Prof_alumnosLow.4a760885.jpg";